var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconExpertiseNovice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 6,
  x: 2,
  y: 11,
  fill: "#FF5722",
  rx: 0.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 10,
  x: 8,
  y: 7,
  fill: "#E0E0E1",
  rx: 0.5
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 14,
  x: 14,
  y: 3,
  fill: "#E0E0E1",
  rx: 0.5
})));
export { SvgIconExpertiseNovice as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iMTEiIHdpZHRoPSI0IiBoZWlnaHQ9IjYiIHJ4PSIwLjUiIGZpbGw9IiNGRjU3MjIiLz4KPHJlY3QgeD0iOCIgeT0iNyIgd2lkdGg9IjQiIGhlaWdodD0iMTAiIHJ4PSIwLjUiIGZpbGw9IiNFMEUwRTEiLz4KPHJlY3QgeD0iMTQiIHk9IjMiIHdpZHRoPSI0IiBoZWlnaHQ9IjE0IiByeD0iMC41IiBmaWxsPSIjRTBFMEUxIi8+Cjwvc3ZnPgo=";